import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

import type * as models from '../../models'
import { transformUsersToAgentAssignments } from '../shared'

const DOC = gql`
  query AgentAssignmentsInApp($tenantId: ID!, $zoneId: ID!, $appId: ID!) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          users {
            items {
              info {
                id
                firstName
                lastName
              }
              agents {
                id
                access
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.default(
  graphql.transformers.OUT.select<
    graphql.schema.AgentAssignmentsInAppQuery,
    readonly models.AgentAssignment[],
    'tenant'
  >(
    'tenant',
    graphql.transformers.OUT.select(
      'zone',
      graphql.transformers.OUT.select(
        'app',
        graphql.transformers.OUT.select(
          'users',
          graphql.transformers.OUT.custom(transformUsersToAgentAssignments),
        ),
      ),
    ),
  ),
  [],
)

export const execute = graphql.createExecutor<
  graphql.schema.AgentAssignmentsInAppQuery,
  readonly models.AgentAssignment[],
  graphql.schema.AgentAssignmentsInAppQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
